import c from "./ghl-ui.es1504.js";
import f from "./ghl-ui.es1505.js";
import s from "./ghl-ui.es1501.js";
import l from "./ghl-ui.es1502.js";
import h from "./ghl-ui.es1503.js";
import o from "./ghl-ui.es1506.js";
import { parseNDigits as v, parseNumericPattern as _, isLeapYearIndex as T } from "./ghl-ui.es1575.js";
import { Parser as P } from "./ghl-ui.es1574.js";
import { numericPatterns as C } from "./ghl-ui.es1576.js";
var D = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], N = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], H = /* @__PURE__ */ function(u) {
  l(i, u);
  var n = h(i);
  function i() {
    var a;
    c(this, i);
    for (var r = arguments.length, e = new Array(r), t = 0; t < r; t++)
      e[t] = arguments[t];
    return a = n.call.apply(n, [this].concat(e)), o(s(a), "priority", 90), o(s(a), "subPriority", 1), o(s(a), "incompatibleTokens", ["Y", "R", "q", "Q", "w", "I", "D", "i", "e", "c", "t", "T"]), a;
  }
  return f(i, [{
    key: "parse",
    value: function(r, e, t) {
      switch (e) {
        case "d":
          return _(C.date, r);
        case "do":
          return t.ordinalNumber(r, {
            unit: "date"
          });
        default:
          return v(e.length, r);
      }
    }
  }, {
    key: "validate",
    value: function(r, e) {
      var t = r.getUTCFullYear(), p = T(t), m = r.getUTCMonth();
      return p ? e >= 1 && e <= N[m] : e >= 1 && e <= D[m];
    }
  }, {
    key: "set",
    value: function(r, e, t) {
      return r.setUTCDate(t), r.setUTCHours(0, 0, 0, 0), r;
    }
  }]), i;
}(P);
export {
  H as DateParser
};
